<template>
  <div>
    <cycles :query="query"></cycles>
  </div>
</template>

<script>
import Cycles from "@/components/Cycles/index.vue";
export default {
  components: { Cycles },
  props: {
    battery: {
      type: Object,
      required: true,
    },
  },
  computed: {
    query() {
      return {
        batteryId: this.battery.id,
      };
    },
  },
};
</script>

<style></style>
